import { FilterValue } from '@src/design-system/filter-new';
import type { TRenderSelectedValuesCtx } from '../../types/filter-config';
import programApi from '@src/features/programs/services/program-api';
import { entityFilterIds } from '../../helpers/filter-none';

const SingleValue = ({ id }: { id: string | number }) => {
  const { data: label } = programApi.useFetchOne({ id });

  return <FilterValue>{label?.name}</FilterValue>;
};

export function ProgramFilterSelectedValues({
  filter,
}: TRenderSelectedValuesCtx) {
  return entityFilterIds(filter.value).map((v) => (
    <SingleValue
      key={v}
      id={v}
    />
  ));
}
